import { removeAccess } from './states';

export const services = {
  removeAccess,
};
